import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-tooltip',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-tooltip works!</p> `,
  styles: ``,
})
export class CpTooltipComponent {}
